export default __webpack_public_path__ + "static/media/saison_inactive.19ba6b0a.svg";